export const GdprCountries: string[] = [
  'Austria',
  'Belgium',
  'Bulgaria',
  'Brazil',
  'Croatia',
  'Cyprus',
  'Czech Republic',
  'Denmark',
  'Estonia',
  'Finland',
  'France',
  'Germany',
  'Greece',
  'Hungary',
  'Ireland',
  'Italy',
  'Latvia',
  'Lithuania',
  'Luxembourg',
  'Malta',
  'the Netherlands',
  'Netherlands',
  'Poland',
  'United Kingdom',
  'Great Britain',
  'Portugal',
  'Romania',
  'Slovakia',
  'Slovenia',
  'Spain',
  'Sweden',
]
